module.exports = __webpack_public_path__ + "assets/img/business@2x.fdb4ad54.png";